import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const messaging = getMessaging(app);

// Listen for foreground messages
onMessage(messaging, (payload) => {
  console.log("Message received in foreground:", payload);
  const { title, body } = payload.notification || {};
  if (title && body && "Notification" in window) {
    new Notification(title, {
      body,
      icon: "/logo192.png",
      badge: "/logo192.png",
      tag: "toilet-notification",
      renotify: true,
      requireInteraction: true,
      vibrate: [200, 100, 200],
    });
  }
});

export const requestNotificationPermission = async () => {
  try {
    // בדיקת תמיכה בנוטיפיקציות
    if (!("Notification" in window)) {
      console.error("This browser does not support notifications");
      return null;
    }

    // בדיקת תמיכה ב-Service Worker
    if (!("serviceWorker" in navigator)) {
      console.error("Service Workers are not supported in this browser");
      return null;
    }

    let permission = Notification.permission;

    // בקשת הרשאה אם צריך
    if (permission !== "granted" && permission !== "denied") {
      permission = await Notification.requestPermission();
      console.log("Notification permission status:", permission);
    }

    if (permission !== "granted") {
      console.log("Notification permission not granted");
      return null;
    }

    // וודא שה-service worker רשום
    const swRegistration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    console.log("Service Worker registered successfully:", swRegistration);

    // המתן ל-service worker שיהיה מוכן
    await navigator.serviceWorker.ready;
    console.log("Service Worker is ready");

    // נסה לקבל FCM טוקן
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: swRegistration,
      });

      if (currentToken) {
        console.log("FCM Token obtained:", currentToken);
        return currentToken;
      } else {
        console.log("No FCM token available. Token couldn't be generated.");
        return null;
      }
    } catch (tokenError) {
      console.error("Error getting FCM token:", tokenError);
      return null;
    }
  } catch (error) {
    console.error("Error in notification setup:", error);
    return null;
  }
};
